import { z } from 'zod';
import { phoneSchema, faxOptionalSchema } from './shared/phone-fax';
export const patientChoiceValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        from: z.object({
            agencyOrFacility: z.string().min(1, 'required'),
            address: z.object({
                street: z.string().min(1, 'required'),
                city: z.string().min(1, 'required'),
                state: z.string().min(1, 'required'),
                zip: z.string().min(1, 'required'),
            }),
            phone: phoneSchema,
            fax: faxOptionalSchema,
        }),
        to: z.object({
            agencyOrFacility: z.string().min(1, 'required'),
            address: z.object({
                street: z.string().min(1, 'required'),
                city: z.string().min(1, 'required'),
                state: z.string().min(1, 'required'),
                zip: z.string().min(1, 'required'),
            }),
            phone: phoneSchema,
            fax: faxOptionalSchema,
        }),
        patientAcknowledgment: z.literal(true, { message: 'requires patient acknowledgment' }),
    }),
});
